(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1178],{

/***/ 5691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(564);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Loader_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function Loader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_3___default().loader_main),
            role: "alertdialog",
            "aria-busy": "true",
            "aria-live": "polite",
            "aria-label": "Loading…",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_3___default().loader),
                    "aria-hidden": "true",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_3___default().loader__sq)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_3___default().loader__sq)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_3___default().loading_text)
                })
            ]
        })
    });
}


/***/ }),

/***/ 1178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Search_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4480);
/* harmony import */ var _Search_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Search_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9198);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_datepicker__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5828);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7349);
/* harmony import */ var _Loader_Loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5691);
/* harmony import */ var _Loader_NewLoader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4538);











function SingleHotelsearchform(props) {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const queryParams = router.query;
    const token = props === null || props === void 0 ? void 0 : props.hotel_token;
    const [openOptions, setOpenOptions] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const optionsRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [loader, setLoader] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [startDate, setStartDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(new Date());
    const [endDate, setEndDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(()=>{
        const tomorrow = (0,date_fns__WEBPACK_IMPORTED_MODULE_8__["default"])(new Date(), 1);
        return tomorrow;
    });
    const [property, setProperty] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [property_city, setProperty_city] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(queryParams.property_city || "");
    const [hotelID, setHotelID] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(2);
    const [adult, setAdults] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(Number(queryParams.adult) || 2);
    const [children, setChildrens] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(Number(queryParams.children) || 0);
    const [rooms, setRooms] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(Number(queryParams.room) || 1);
    const [noOfNights, setNoOfNights] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(queryParams.npOfNights || 1);
    const [childAge, setChildAge] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [updatedRooms, setUpdatedRooms] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const [checkin, setCheckin] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        day: router.query.checkinDay || "",
        month: router.query.checkinMonth || "",
        year: router.query.checkinYear || ""
    });
    const [checkout, setCheckout] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        day: router.query.checkoutDay || "",
        month: router.query.checkoutMonth || "",
        year: router.query.checkoutYear || ""
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const updateDateState = (date, setStateFunction)=>{
            if (date !== null) {
                const day = date.getDate();
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const year = date.getFullYear();
                setStateFunction({
                    day,
                    month,
                    year
                });
            }
        };
        updateDateState(startDate, setCheckin);
        updateDateState(endDate, setCheckout);
        const nights = moment__WEBPACK_IMPORTED_MODULE_4___default()(endDate).diff(moment__WEBPACK_IMPORTED_MODULE_4___default()(startDate), "days");
        setNoOfNights(nights > 0 ? nights : 1);
    }, [
        startDate,
        endDate
    ]);
    const onChange = (dates)=>{
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        const dateRange = "".concat(moment__WEBPACK_IMPORTED_MODULE_4___default()(start).format("YYYY-MM-DD"), "+").concat(moment__WEBPACK_IMPORTED_MODULE_4___default()(end).format("YYYY-MM-DD"));
        ;
    };
    const formated_start_date = moment__WEBPACK_IMPORTED_MODULE_4___default()(startDate).format("YYYY-MM-DD");
    const formated_end_date = moment__WEBPACK_IMPORTED_MODULE_4___default()(endDate).format("YYYY-MM-DD");
    const checkin_out_date = moment__WEBPACK_IMPORTED_MODULE_4___default()(startDate).format("YYYY-MM-DD") + "+" + moment__WEBPACK_IMPORTED_MODULE_4___default()(endDate).format("YYYY-MM-DD");
    const onAdultIncrease = ()=>{
        const newAdult = adult + 1;
        setAdults(newAdult);
        if (newAdult > 1 && newAdult % 2 === 0 && rooms < newAdult / 2) {
            setRooms(rooms + 1);
        }
    };
    const onAdultDecrease = ()=>{
        if (adult > 1) {
            const newAdult = adult - 1;
            setAdults(newAdult);
            if (newAdult % 2 !== 0 && rooms > 1) {
                setRooms(rooms - 1);
            }
        }
    };
    const handleChildrenAgeChange = (index, event)=>{
        const ages = [
            ...childAge
        ];
        ages[index] = event.target.value;
        setChildAge(ages);
    };
    const onChildDecrease = (e)=>{
        e.preventDefault();
        // if (children > 0) {
        setChildrens(children - 1);
        setChildAge(childAge.slice(0, childAge.length - 1));
    // }
    };
    const onChildIncrease = (e)=>{
        e.preventDefault();
        // if (children < 2) {
        setChildrens(children + 1);
        setChildAge([
            ...childAge,
            ""
        ]);
    // }
    };
    const formatDate = (date)=>{
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        return "".concat(year, "-").concat(month, "-").concat(day);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (router.query.checkinDay && router.query.checkinMonth && router.query.checkinYear && router.query.checkoutDay && router.query.checkoutMonth && router.query.checkoutYear) {
            const { checkinDay , checkinMonth , checkinYear , checkoutDay , checkoutMonth , checkoutYear  } = router.query;
            const formatDateToString = (year, month, day)=>{
                const paddedMonth = String(month).padStart(2, "0");
                const paddedDay = String(day).padStart(2, "0");
                return "".concat(year, "-").concat(paddedMonth, "-").concat(paddedDay);
            };
            const checkInDateString = formatDateToString(checkinYear, checkinMonth, checkinDay);
            const checkOutDateString = formatDateToString(checkoutYear, checkoutMonth, checkoutDay);
            const checkInDate = new Date(checkInDateString);
            const checkOutDate = new Date(checkOutDateString);
            setStartDate(checkInDate);
            setEndDate(checkOutDate);
        }
    }, [
        router.query.checkinDay,
        router.query.checkinMonth,
        router.query.checkinYear,
        router.query.checkoutDay,
        router.query.checkoutMonth,
        router.query.checkoutYear
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (Object.keys(router.query).length > 0) {
            const childrenCount = parseInt(router.query.children) || 0;
            const childAges = [];
            if (childrenCount > 0) {
                for(let i = 1; i <= childrenCount; i++){
                    const childAgeKey = "childAge[".concat(i, "]");
                    if (router.query.hasOwnProperty(childAgeKey)) {
                        childAges.push(router.query[childAgeKey]);
                    }
                }
            }
            setAdults(Number(router.query.adult) || 2);
            setChildrens(Number(router.query.children) || 0);
            setRooms(Number(router.query.room) || 1);
            setNoOfNights(router.query.npOfNights || 1);
            setChildAge(childAges);
        }
    // setChildAge(childAges);
    }, [
        router.query
    ]);
    // useEffect(() => {
    //     if (router.query.checkinDay && router.query.checkinMonth && router.query.checkinYear && router.query.checkoutDay && router.query.checkoutMonth && router.query.checkoutYear) {
    //         const { checkinDay, checkinMonth, checkinYear, checkoutDay, checkoutMonth, checkoutYear } = router.query;
    //         const checkInDate = new Date(`${checkinYear}-${checkinMonth}-${checkinDay}`);
    //         const checkOutDate = new Date(`${checkoutYear}-${checkoutMonth}-${checkoutDay}`);
    //         const formattedCheckIn = formatDate(checkInDate);
    //         const formattedCheckOut = formatDate(checkOutDate);
    //         setStartDate(new Date(formattedCheckIn));
    //         setEndDate(new Date(formattedCheckOut));
    //     }
    // }, [router.query.checkinDay, router.query.checkinMonth, router.query.checkinYear, router.query.checkoutDay, router.query.checkoutMonth, router.query.checkoutYear]);
    const handleSubmit = async (event)=>{
        event.preventDefault();
        let hasChildAgeError = false;
        const sanitizedChildAges = childAge.map((age)=>age !== "" ? age : null).filter((age)=>age !== null);
        const childAgeParams = sanitizedChildAges.map((age, index)=>{
            if (age > 12) {
                alert("Child age must be between 0 and 12");
                hasChildAgeError = true;
                return;
            }
            return "&childAge[".concat(index + 1, "]=").concat(age);
        }).join("");
        if (hasChildAgeError) {
            return;
        }
        if (endDate <= startDate) {
            alert("Check out must be a date after check in");
            return;
        }
        setLoader(true);
        try {
            await router.push("/searchresults/?hotelID=".concat(hotelID, "&checkinDay=").concat(checkin.day, "&checkinMonth=").concat(checkin.month, "&checkinYear=").concat(checkin.year, "&checkoutDay=").concat(checkout.day, "&checkoutMonth=").concat(checkout.month, "&checkoutYear=").concat(checkout.year, "&room=").concat(rooms, "&adult=").concat(adult, "&children=").concat(children).concat(childAgeParams, "&checkIn=").concat(formated_start_date, "&checkOut=").concat(formated_end_date, "&noOfNights=").concat(noOfNights, "#rooms-details"), undefined, {
                shallow: false
            });
            setLoader(false);
            setOpenOptions(false);
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (optionsRef.current && !optionsRef.current.contains(event.target)) {
                setOpenOptions(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "search_form",
        children: [
            loader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loader_NewLoader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                className: "".concat((_Search_module_scss__WEBPACK_IMPORTED_MODULE_9___default().homepage_search_box)),
                onSubmit: (event)=>handleSubmit(event),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_Search_module_scss__WEBPACK_IMPORTED_MODULE_9___default().singlehotel_searchbox_child)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                style: {
                                    textAlign: "left",
                                    height: "18px"
                                },
                                children: "Check-In Check-Out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_datepicker__WEBPACK_IMPORTED_MODULE_10___default()), {
                                name: "date_range",
                                placeholderText: "Please select a date",
                                selected: startDate,
                                onChange: onChange,
                                startDate: startDate,
                                className: "date_input_form",
                                endDate: endDate,
                                minDate: new Date(),
                                selectsRange: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_Search_module_scss__WEBPACK_IMPORTED_MODULE_9___default().singlehotel_searchbox_child)),
                        style: {
                            border: "none"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                style: {
                                    textAlign: "left",
                                    height: "20px"
                                },
                                children: "Adults - Rooms - Children"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_Search_module_scss__WEBPACK_IMPORTED_MODULE_9___default().search_item),
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        onClick: ()=>setOpenOptions(!openOptions),
                                        className: "headerSearchText",
                                        style: {
                                            width: "100%"
                                        },
                                        children: "".concat(adult, " adult \xb7 ").concat(rooms, " rooms \xb7 ").concat(children, " children")
                                    }),
                                    openOptions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "options",
                                        ref: optionsRef,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "optionItem",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "optionText",
                                                        children: "Adult"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "optionCounter",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                type: "button",
                                                                disabled: adult <= 1,
                                                                className: "optionCounterButton",
                                                                onClick: onAdultDecrease,
                                                                children: "-"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                name: "adult",
                                                                className: "optionCounterNumber",
                                                                value: adult,
                                                                readOnly: true
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                type: "button",
                                                                className: "optionCounterButton",
                                                                onClick: onAdultIncrease,
                                                                children: "+"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "optionItem",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "optionText",
                                                        children: "Room"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "optionCounter",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                type: "button",
                                                                disabled: rooms <= 1,
                                                                className: "optionCounterButton",
                                                                onClick: (e)=>{
                                                                    e.preventDefault();
                                                                    setRooms(rooms - 1);
                                                                },
                                                                children: "-"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                name: "rooms",
                                                                className: "optionCounterNumber",
                                                                value: rooms,
                                                                readOnly: true
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                type: "button",
                                                                className: "optionCounterButton",
                                                                onClick: (e)=>{
                                                                    e.preventDefault();
                                                                    setRooms(rooms + 1);
                                                                },
                                                                children: "+"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "optionItem",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "optionText",
                                                        children: "Children"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "optionCounter",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                type: "button",
                                                                disabled: children <= 0,
                                                                className: "optionCounterButton",
                                                                onClick: onChildDecrease,
                                                                children: "-"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                name: "children",
                                                                className: "optionCounterNumber",
                                                                value: children,
                                                                readOnly: true
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                type: "button",
                                                                className: "optionCounterButton",
                                                                onClick: onChildIncrease,
                                                                children: "+"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            childAge.map((age, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "optionItem",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "optionText",
                                                            children: [
                                                                "Child ",
                                                                index + 1,
                                                                " Age"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "optionCounter",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                className: "childAge_input",
                                                                type: "number",
                                                                name: "childAge[]",
                                                                min: "1",
                                                                // max="12"
                                                                value: age,
                                                                onChange: (event)=>handleChildrenAgeChange(index, event),
                                                                required: true
                                                            })
                                                        })
                                                    ]
                                                }, index))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_Search_module_scss__WEBPACK_IMPORTED_MODULE_9___default().searchbox_btn_child)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "submit",
                                className: "".concat((_Search_module_scss__WEBPACK_IMPORTED_MODULE_9___default().submit_btn)),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                    width: "27",
                                    height: "28",
                                    viewBox: "0 0 27 28",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                            children: "This is a icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M11.3448 22.1897C17.0581 22.1897 21.6897 17.5581 21.6897 11.8448C21.6897 6.13154 17.0581 1.5 11.3448 1.5C5.63154 1.5 1 6.13154 1 11.8448C1 17.5581 5.63154 22.1897 11.3448 22.1897Z",
                                            stroke: "white",
                                            strokeWidth: "2",
                                            strokeMiterlimit: "10"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M18.2414 18.7414L26 26.5",
                                            stroke: "white",
                                            strokeWidth: "2",
                                            strokeMiterlimit: "10"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "submit",
                                className: (_Search_module_scss__WEBPACK_IMPORTED_MODULE_9___default().submit_btn_mobile),
                                children: "Search Rooms"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SingleHotelsearchform);


/***/ }),

/***/ 4480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search_form":"Search_search_form__X3nV9","homepage_search_box":"Search_homepage_search_box___YIQc","searchbox_child":"Search_searchbox_child__RQrQF","singlehotel_searchbox_child":"Search_singlehotel_searchbox_child__SCPKC","button_con":"Search_button_con__mj6HD","search_item":"Search_search_item__R78Km","inc_dec_btn":"Search_inc_dec_btn__T_Lvv","select_con":"Search_select_con__VRej6","searchbox_btn_child":"Search_searchbox_btn_child__f0ssA","submit_btn":"Search_submit_btn__sVeN7","submit_btn_mobile":"Search_submit_btn_mobile__Mj06_","test_search_box":"Search_test_search_box__m_EdW","select_label":"Search_select_label__ZUMi3","default_text":"Search_default_text__eL_68","options":"Search_options__g7lx4","optionItem":"Search_optionItem__nBEc6","optionCounter":"Search_optionCounter__tl4BO"};

/***/ })

}]);